<template>
  <div class="salesmanSettingPage">
    <XR-head titleText="店铺设置" :rightShow="false" ref="headObj"></XR-head>
    <div>      
      <mu-row gutter>
        <mu-col width="100" tablet="100" desktop="100" class="rowFiled">
          <mu-text-field label="商城名称" type="text" helpText="" labelFloat fullWidth v-model="editInfo.sName" />
        </mu-col>
      </mu-row>      
      <mu-row gutter>
        <mu-col width="100" tablet="100" desktop="100" class="rowFiled">
          <mu-text-field label="真实姓名" type="text" helpText="" labelFloat fullWidth v-model="editInfo.tName" />
        </mu-col>
      </mu-row>   
      <mu-row gutter>
        <mu-col width="100" tablet="100" desktop="100" class="rowFiled">
          <mu-text-field label="手机号码" type="text" helpText="" labelFloat fullWidth v-model="editInfo.mobile" />
        </mu-col>
      </mu-row>         
      <mu-row gutter>
        <mu-col width="100" tablet="100" desktop="100" class="rowFiled">
          <mu-text-field label="微信号" type="text" helpText="" labelFloat fullWidth v-model="editInfo.wx" />
        </mu-col>
      </mu-row>    
      <mu-row gutter>
        <mu-col width="100" tablet="50" desktop="50" class="btn-div">          
          <mu-raised-button label="保 存" class="submit" primary fullWidth @click="submit()" />
        </mu-col>
      </mu-row>   
    </div>
    <XR-toast @onClose="goBack" ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
export default {
  data () {
    return {
      editInfo:{
        sName : '',
        tName:'',
        mobile:'',
        wx:'',
        e:1
      }
    }
  },
  mounted(){
    this.getSetting()
  },
  methods: {
    getSetting: function(){
      var ths = this;  
      
      ths.$post(
        "/Salesman/SalesmanServer/GetShopSetting"
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{
          ths.editInfo.sName =  res.Data.ShopName
          ths.editInfo.tName = res.Data.TrueName
          ths.editInfo.mobile = res.Data.MobileNo
          ths.editInfo.wx = res.Data.WxNo
        }
      });
    },
    submit: function(){
      var ths = this;  
      
      ths.$post(
        "/Salesman/SalesmanServer/ShopSetting",
        JSON.stringify(this.editInfo)
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{
          ths.$refs.XRtoast.success(res.Msg, true)
        }
      });
    },
    goBack(){
      this.$router.goBack()
    }
  }
}
</script>
<style>
 body .salesmanSettingPage{
  background: white;
}
.salesmanSettingPage .rowFiled{
  padding: 0 5%;
}
.salesmanSettingPage .forgetBtn {
  float: right;
}

.salesmanSettingPage .btn-div {
  padding: 40px 5% 30px;
}
.salesmanSettingPage .submit {
  height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/pages/salesman/setting.vue